import { format } from 'date-fns/format';
import { ExportAccountingTransferOrderFormValues } from '@/components/forms/export-accounting-transfer-order-form/schema';
import { useExportAccountingTransferOrderUseForm } from '@/components/forms/export-accounting-transfer-order-form/use-export-accounting-transfer-order-form';
import useAccountingExportTransferOrderMutation from '@/hooks/mutations/use-accounting-export-transfer-order';
import { popModal } from '..';

export type ExportAccountingTransferOrderModalApi = {
  onSuccess?: ({ data, filename }: { data: Blob; filename: string }) => void;
  onClose?: () => void;
  onCancel?: () => void;
};
export const useExportAccountingTransferOrderModalViewModel = ({
  api,
}: {
  api: ExportAccountingTransferOrderModalApi;
}) => {
  const { exportAccountingTransferOrderForm: exportForm } =
    useExportAccountingTransferOrderUseForm();

  const closeAddDcotor = () => {
    popModal('ExportAccountingTransferOrderModal');
    api.onClose?.();
  };

  const cancelAddDoctor = () => {
    popModal('ExportAccountingTransferOrderModal');
    api.onCancel?.();
  };

  const { mutate: exportTransferOrder, isPending } =
    useAccountingExportTransferOrderMutation();

  const submitExport = (values: ExportAccountingTransferOrderFormValues) => {
    const filename = `accountings-transfer-order-${format(values.period.from, 'yyyy-MM-dd')}-${format(values.period.to, 'yyyy-MM-dd')}.zip`;

    exportTransferOrder(
      {
        officeIds: values.officeIds,
        doctorAttendingIds:
          values.officeIds.length === 1 &&
          values.doctorAttendingIds &&
          values.doctorAttendingIds.length > 0
            ? values.doctorAttendingIds
            : undefined,
        from: values.period.from,
        to: values.period.to,
      },
      {
        onSuccess: (data) => {
          popModal('ExportAccountingTransferOrderModal');
          api.onSuccess?.({ filename, data });
        },
      },
    );
  };

  return {
    api: {
      submit: () => {
        exportForm.trigger();
        exportForm.handleSubmit(submitExport)();
      },
      close: closeAddDcotor,
      cancel: cancelAddDoctor,
    },
    form: exportForm,
    data: {
      saving: isPending,
    },
  };
};

export type ExportAccountingTransferOrderModalViewModel = ReturnType<
  typeof useExportAccountingTransferOrderModalViewModel
>;
